var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-card"},[(_vm.$slots.head)?_c('div',{staticClass:"head"},[_vm._t("head")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }